export default function getTrackName(event) {
  return event.track?.name || event.track?.metadata?.originalTrackName || ''
}
